"use client"

import { useEffect, useState } from "react";
import Image from "next/image";
import { getOEmbed, OEmbedResult } from "@/actions/embed_links";
import Link from "next/link";

export function LinkCard({url}:{
    url?: string;
}){
    const [embed, setEmbed] = useState<OEmbedResult | null>(null);
    useEffect(() => {
        async function fetchEmbed(){
            try {
                if(!url){
                    return;
                }
                const res = await getOEmbed(url);
                setEmbed(res);
            } catch (e){
                console.error(e);
            }
        }
        fetchEmbed();
    }, [url])
    if(!url){
        return (
            <div className="relative w-full bg-gray-200 aspect-[4/3]">
                <div className='flex items-center justify-center w-full h-full bg-gray-300 text-gray-500'>
                    No image available
                </div>
            </div>
        )
    }
    if(!embed || embed.error || !embed.meta){
        return (
            <Link href={url} target="_blank" rel="noreferrer" className="block border rounded-lg overflow-hidden cursor-pointer">
                <div className="relative w-full h-48 bg-gray-100">
                    <div className="w-full h-full flex items-center justify-center text-gray-400">No image</div>
                </div>

                <div className="p-3">
                    <div className="text-xs text-gray-500 mb-1">{url}</div>
                    <div className="text-xs text-blue-600 mt-2 break-all">{new URL(url).hostname}</div>
                </div>
            </Link>
        );
    }
    const {meta} = embed;
    return (
        <Link href={meta.url || url} target="_blank" rel="noreferrer" className="block border rounded-lg overflow-hidden cursor-pointer">
            <div className="relative w-full bg-gray-100">
                {meta.thumbnail_url ? (
                // If using next/image, configure remotePatterns or supply a loader in next.config.js
                <Image src={meta.thumbnail_url} alt={meta.title || 'image'} className="w-full h-full object-cover" height={500} width={500} />
                ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-400">No image</div>
                )}
            </div>

            <div className="p-3">
                <div className="text-xs text-gray-500 mb-1">{meta.url}</div>
                <h3 className="font-semibold leading-tight line-clamp-2">{meta.title}</h3>
                {meta.author_name && <p className="text-sm text-gray-600 mt-1 line-clamp-3">{meta.author_name}</p>}
                {meta.url && <div className="text-xs text-blue-600 mt-2 break-all">{new URL(meta.url).hostname}</div>}
            </div>
        </Link>
    )
}